/**
 * 获取处理后的租户LOGO
 * case1: url不存在, 返回 undefined
 * case2: 没有跨域，返回 LOGO Url
 * case3: 跨域，返回 null （生成不带图标的二维码，返回其他值会导致生成二维码异常）
 * */
export function getHandledTenantLogo(url?: string): string | undefined | null {
    if (!url) return void 0;
    try {
        let newUrl = url;
        const { protocol: currentProtocol, host: currentHost, port: currentPort } = window.location;
        if (url.startsWith('//')) newUrl = `${currentProtocol}${url}`; // 确保此种情况 new URL 不失败
        const parsedUrl = new URL(newUrl);
        if (
            parsedUrl.protocol === currentProtocol
            && parsedUrl.host === currentHost
            && parsedUrl.port === currentPort
        ) {
            return url;
        }
        return null;
    } catch (error) {
        return null;
    }
}
